import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'slices/store';

export enum SqFormType {
  None = 'None',
  LoginForm = 'LoginForm',
  RegisterForm = 'RegisterForm',
  ForgotPasswordForm = 'ForgotPasswordForm',
  AnonymousUserForm = 'AnonymousUserForm',
}

export interface BaseForm {
  formType: SqFormType;
}

export interface LoginForm extends BaseForm {
  email: string;
  password: string;
}

export interface RegisterForm extends LoginForm {
  name: string;
}

export interface ForgotPasswordForm extends BaseForm {
  email: string;
}

export interface AnonymousUserForm extends BaseForm {
  name: string;
}

export type TypesOfForms = LoginForm | RegisterForm | ForgotPasswordForm | AnonymousUserForm;

export interface SqFormProps {
  activeForm: TypesOfForms | undefined;
  activeFormType: SqFormType;
}

const initialState: SqFormProps = {
  activeForm: undefined,
  activeFormType: SqFormType.None,
};

export const sqFormSlice = createSlice({
  name: 'sqform',
  initialState,
  reducers: {
    setForm: (state, action: PayloadAction<TypesOfForms>) => {
      state.activeForm = action.payload;
      state.activeFormType = action.payload.formType;
    },
    setFormType: (state, action: PayloadAction<SqFormType>) => {
      state.activeFormType = action.payload;
    },
    // RESET ******************************************************************
    resetActiveForm: () => {
      return { ...initialState };
    },
  },
});

export const {
  // USER
  setForm,
  setFormType,

  resetActiveForm,
} = sqFormSlice.actions;

export const getForm = (state: RootState): TypesOfForms | undefined => state.sqform.activeForm;
export const getFormType = (state: RootState): SqFormType => state.sqform.activeFormType;
export const getIsActiveForm = (state: RootState): boolean => state.sqform.activeForm !== undefined;

export default sqFormSlice.reducer;
